import React from 'react';
import { TextBoxStyles } from './text-body.styles';

const TextBody = ({type, text, stat}) => {

    return(
        <TextBoxStyles type={type}>
            {/* <pre>{text}</pre> */}
            {text}
            <span>{stat}</span>
        </TextBoxStyles>
    )
}

export default TextBody;